import {
	addNewTranslation,
	getTranslationByLang,
} from './repositories/translations';

class TransaltionManager {
	async getLanguage(userId) {
		const response = await getTranslationByLang(userId);

		if (response.data) {
			localStorage.removeItem('translations');
			const stringLang = JSON.stringify(response.data);
			localStorage.setItem('translations', stringLang);
		}
	}

	async getTranslation(word, userId) {
		let translations = JSON.parse(localStorage.getItem('translations')) || [];

		let translatedWord = translations.find(
			(translation) => translation.value === word,
		);
		if (translatedWord) {
			return translatedWord.label;
		}

		await this.getLanguage(userId);

		translations = JSON.parse(localStorage.getItem('translations')) || [];

		translatedWord = translations.find(
			(translation) => translation.value === word,
		);
		if (translatedWord) {
			return translatedWord.label;
		}

		await addNewTranslation(word);

		return word;
	}
}

const transaltionManager = new TransaltionManager();
export default transaltionManager;
